import { Language, VenueType } from '../enum/EnumRepository';
import { useLanguageStore } from '../store/languageStore';

export const VENUE_TYPE_LABELS: Record<VenueType, Record<Language, string>> = {
  [VenueType.ART_MUSEUM]: {
    [Language.EN]: 'Art Museum',
    [Language.KR]: '미술관',
  },
  [VenueType.GALLERY]: {
    [Language.EN]: 'Gallery',
    [Language.KR]: '갤러리',
  },
  [VenueType.ALTERNATIVE_SPACE]: {
    [Language.EN]: 'Alternative Space',
    [Language.KR]: '대안공간',
  },
  [VenueType.ART_CENTER]: {
    [Language.EN]: 'Art Center',
    [Language.KR]: '아트센터',
  },
  [VenueType.CULTURAL_COMPLEX]: {
    [Language.EN]: 'Cultural Complex',
    [Language.KR]: '복합문화공간',
  },
  [VenueType.PROJECT_SPACE]: {
    [Language.EN]: 'Project Space',
    [Language.KR]: '프로젝트 스페이스',
  },
  [VenueType.OTHER]: {
    [Language.EN]: 'Other',
    [Language.KR]: '기타',
  },
};

export type VenueFilterLabelKey =
  | 'TYPE'
  | 'ADMISSION'
  | 'FREE_ONLY'
  | 'FREE'
  | 'TODAY_OPEN'
  | 'OPEN_TODAY';

/** 필터 섹션/칩 라벨. 공간(venue) 기준 표현 */
export const VENUE_FILTER_LABELS: Record<VenueFilterLabelKey, Record<Language, string>> = {
  TYPE: {
    [Language.EN]: 'Space type',
    [Language.KR]: '공간 유형',
  },
  ADMISSION: {
    [Language.EN]: 'Admission',
    [Language.KR]: '입장',
  },
  FREE_ONLY: {
    [Language.EN]: 'Free only',
    [Language.KR]: '무료만',
  },
  FREE: {
    [Language.EN]: 'Free',
    [Language.KR]: '무료',
  },
  TODAY_OPEN: {
    [Language.EN]: 'Operating day',
    [Language.KR]: '운영일 여부',
  },
  OPEN_TODAY: {
    [Language.EN]: 'Open today',
    [Language.KR]: '당일 운영중',
  },
};

export const getVenueTypeLabel = (
  type: VenueType,
  language: Language = useLanguageStore.getState().language,
): string => (
  VENUE_TYPE_LABELS[type]?.[language]
  ?? VENUE_TYPE_LABELS[type]?.[Language.EN]
  ?? type
);

export const getVenueFilterLabel = (
  key: VenueFilterLabelKey,
  language: Language = useLanguageStore.getState().language,
): string => (
  VENUE_FILTER_LABELS[key]?.[language]
  ?? VENUE_FILTER_LABELS[key]?.[Language.EN]
  ?? key
);

export const getVenueDisplayName = (
  venue: { name: string; nameEn?: string | null },
  language: Language = useLanguageStore.getState().language,
): string => {
  if (language === Language.EN) {
    return venue.nameEn?.trim() || venue.name;
  }
  return venue.name;
};
